<div class="container">
	<div class="privacy_policy_view">
		<h4>{{refundPolicyArr?.title}}</h4>
		<div [innerHtml]="refundPolicyArr?.body">

		</div>
	</div>
</div>
